interface RedemptionSheetChipProps {
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

/**
 * A selectable filter chip in the mobile filter sheet (Category / Cause). Selected
 * uses a dust-ink fill with white text (clears AA, unlike dark-dust). Matches the
 * prototype's `.fsheet-chip`.
 */
export default function RedemptionSheetChip({
  selected,
  onClick,
  children,
}: RedemptionSheetChipProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={`relative cursor-pointer rounded-full border px-3.75 py-2.25 font-lato text-[13px] font-semibold transition-colors after:absolute after:inset-x-0 after:-top-[2px] after:-bottom-[8px] after:content-[''] ${
        selected ? "border-dust-ink bg-dust-ink text-white" : "border-smoke bg-white text-graphite"
      }`}
    >
      {children}
    </button>
  );
}
